<template>
  <slot name="loading" v-if="loading">
    <div>Loading robot check</div>
  </slot>
  <slot v-bind="{ challenge, response }" v-if="challenge && challenge.challenge !== 'GoogleRecaptchaV3'">
    <template v-if="challenge.challenge === 'GoogleRecaptchaV2'">
      <div ref="response"></div>
    </template>
    <template v-else>
      <label>{{ challenge.label }}</label>
      <input type="text" v-model="response" />
    </template>
  </slot>
  <input type="text" :value="value" v-bind="$attrs" class="hidden show-hidden-error" />
</template>

<script>
import { ref, watch, onMounted, computed, nextTick, watchEffect } from 'vue'
import loadRecaptcha from '../utils/loadRecaptcha'
import $formValues from '../nette/FormValues'
import LiveForm from '../nette/LiveForm'
import NetteAjax from '../nette/NetteAjax'

export default {
  props: {
    action: String,
    formId: {
      type: String,
      required: true,
    },
  },
  setup(props, { attrs }) {
    const loading = ref(false)
    const challenge = ref(null)
    const response = ref(null)

    const ctx = {
      loading,
      challenge,
      response,
      value: computed({
        get() {
          return $formValues[attrs.id]
        },
        set(val) {
          $formValues[attrs.id + ':change'] = val
        },
      }),
    }

    const checkChallenge = (data) => {
      loading.value = true
      NetteAjax.ajax({
        url: `/service/recaptcha/check?challenge=${data.challenge}&response=${data.response}`,
        off: ['vue-render', 'spinner', 'vue-router', 'cache', 'unique'],
      }).then((response) => {
        loading.value = false
        setChallenge(response)
      })
    }

    let stopWatchEffect = null
    const setChallenge = (data) => {
      if (stopWatchEffect) {
        stopWatchEffect()
      }

      challenge.value = data

      if (data.hash && data.response && data.ts) {
        ctx.value.value = JSON.stringify(data)
        setTimeout(() => {
          checkChallenge(data)
        }, 80000)
      }

      nextTick(() => {
        if (data.challenge in challenges) {
          challenges[data.challenge](data)
        } else {
          challenges.default(data)
        }
      })
    }

    const challenges = {
      GoogleRecaptchaV3: (data) => {
        if (data.hash && data.response && data.ts) {
          return
        }

        loading.value = true
        loadRecaptcha(data.siteKey).then((grecaptcha) => {
          grecaptcha.ready(() => {
            grecaptcha.execute(data.siteKey, { action: props.action }).then((token) => {
              data.response = token
              checkChallenge(data)
            })
          })
        })
      },
      GoogleRecaptchaV2: (data) => {
        if (data.hash && data.response && data.ts) {
          return
        }

        loading.value = true
        loadRecaptcha().then((grecaptcha) => {
          grecaptcha.ready(() => {
            grecaptcha.render(response.value, {
              sitekey: data.siteKey,
              callback: (token) => {
                data.response = token
                checkChallenge(data)
              },
            })

            loading.value = false
            ctx.value.value = '' // show error message
          })
        })
      },
      default: (data) => {
        stopWatchEffect = watchEffect(() => {
          if (response.value) {
            data.response = response.value
            ctx.value.value = JSON.stringify(data)
          } else {
            ctx.value.value = '' // show error message
          }
        })
      },
    }

    onMounted(() => {
      setTimeout(() => {
        const form = document.getElementById(props.formId)
        LiveForm.Nette.validateForm(form, true)
        const formErrorElements = LiveForm.getFormProperty(form, 'errorElements')
        let loaded = false
        watch(
          formErrorElements,
          (formHasError) => {
            if (loaded || Object.keys(formHasError).length > 1) {
              return
            }

            loaded = true
            setChallenge(JSON.parse(ctx.value.value))
          },
          { immediate: true }
        )
      }, 500)
    })

    return ctx
  },
}
</script>
